export type ApplePayStatusMessage = {
  epochTimestamp: number;
  expiresAt: number;
  merchantSessionIdentifier: string;
  nonce: string;
  merchantIdentifier: string;
  domainName: string;
  displayName: string;
  signature: string;
  operationalAnalyticsIdentifier: string;
  retries: number;
  pspId: string;
};

export type ApplePayValidateMerchantRequestData = {
  url: string;
  merchantIdentifier: string;
  displayName: string;
  initiative: string;
  initiativeContext: string;
};

export type ApplePayShippingAddressResponse = {
  newTotal: number;
  shippingCost: number;
  discount: number;
  subTotal: number;
  totalVoucherAmount: number;
};
